import React, { useEffect, useLayoutEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Select from "@mui/material/Select";
import "./NavBar.css";
import fr from "../../../assets/fr.png";
import en from "../../../assets/en.png";
import {ReactComponent as CloseIcon} from "../../../assets/close-modal.svg"
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Hooks } from "../../utils/hooks";
import { GlobalHooks } from "../../../utils/Hooks"
import { useAppSelector } from "../../../redux/hooks";
import {useWindowSize} from "../../utils/resize"
import Logo from "../../../assets/logo_dam.png";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import HasPermission from "../HasPermission/HasPermission";
import books from "../../../router/Books";
import { Dialog, Modal } from "@mui/material";
import { ApiKey } from "../CléApi/ApiKey";
import {ReactComponent as VpnKeyIcon} from "../../../assets/api_key.svg"
import {ReactComponent as AccountCircleIcon} from "../../../assets/profil.svg"
import {ReactComponent as SettingsIcon} from "../../../assets/display_option.svg"
import {ReactComponent as HelpIcon} from "../../../assets/user_guide.svg"
import {ReactComponent as ExitToAppIcon} from "../../../assets/logout.svg"
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import DefaultImage from "../../../assets/admin.jpg";
import { GraphQLFetchData } from "../Profile/utils/GraphFetchData";


const MenuProps = {
  PaperProps: {
    style: {
      boxShadow: "0px 1px 9px -1px rgba(0, 0, 0, 0.15)",
      borderRadius:"15px",
      marginTop:"2px"
    },
  },
};
const Navbar = ({ open, handleOnCollapse, setOpenTheBook }) => {
  const {GetUserData} = GraphQLFetchData()
  const permissions = useAppSelector((state) => state.ConnexionReducer.constraintData.permissions)
  const isAdmin = useAppSelector((state) => state.ConnexionReducer.constraintData.isAdmin)
  const newUserData = useAppSelector((state) => state.ProfileReducer.ProfileConstraintsDataUpdated)
  const vignetteUser = useAppSelector((state) => state.ProfileReducer.vignette)
  const {id} = useAppSelector((state) => state.ConnexionReducer.constraintData)
  const {cookies,setCookie} = GlobalHooks()
  const { t } = useTranslation();
  const { pathname } = useLocation();
  // breadcrump : 
  const moduleName = pathname.split("/")?.[1] || ""
  const subModuleName = pathname.split("/")?.[2] || ""
  const subSubModuleName = pathname.split("/")?.[3] || ""
  const [wid,setWid] = useState()
  const [openModal, setOpenModal] = useState(false)
  const handleCloseModal = () => setOpenModal(false)
  const handleOpenModal = () => setOpenModal(true)
  const history = useHistory();
  const {handleLogout} = Hooks()
  const {thumbnail,username} = useAppSelector(state=>state.ConnexionReducer.connexion)
  // profile dropdown state
  const [openProfileBar, setOpenProfileBar] = useState(true)
  const [openDropdown, setOpenDropdown] = useState(false)
  const changeLanguage = (e) => {
    i18next.changeLanguage(e);
    setCookie("language",e,{path:"/"})
        if(document.getElementById('iframe_dashboardStats_display'))
        {
          document.getElementById('iframe_dashboardStats_display').contentWindow.postMessage({
            info: "updateLang",
            lang:e
          }, "*");
        }
        if(document.getElementById('iframe_statsDirect_display'))
        {
          document.getElementById('iframe_statsDirect_display').contentWindow.postMessage({
            info: "updateLang",
            lang:e
          }, "*");
        }
    
        if(document.getElementById('iframe_statsVideos_display'))
        {
          document.getElementById('iframe_statsVideos_display').contentWindow.postMessage({
            info: "updateLang",
            lang:e
          }, "*");
        }
        if(document.getElementById('iframe_statsAudit_display'))
        {
          document.getElementById('iframe_statsAudit_display').contentWindow.postMessage({
            info: "updateLang",
            lang:e
          }, "*");
        }
        if(document.getElementById('iframe_statsExports_display'))
        {
          document.getElementById('iframe_statsExports_display').contentWindow.postMessage({
            info: "updateLang",
            lang:e
          }, "*");
        }
  };
  const hide = useWindowSize()

  useEffect(()=>{
    setWid(hide >= 960)
  },[hide])
  useLayoutEffect(()=>{
    if(id || cookies.id){
      GetUserData({variables:{id:id ? id : cookies.id }})
    }
  },[id,cookies.id])

  const openLinkInNewWindow = () => {
    window.open("https://support.empreinte.com/docs/bo/html/index.html", "_blank");
  }
  const [timer, setTimer] = useState(0)
  const handleCloseDropdown = () => { 
    let timerId = setTimeout(() => { 
      setOpenProfileBar(false)
     }, 10000)
     setTimer(timerId)
   }
  const handleStopTimerDropdown = () => {
    clearTimeout(timer);
  }

  return (
    <div className={`navbar-container ${(cookies.LayoutTheme !== "L3" && cookies.LayoutTheme !== "L2" && cookies.LayoutTheme !== "L4") ? open ? "secondeLayoutModif" : "secondeLayoutModifUndo" : ""} `}>
      <AppBar position="static" 
      sx={{ backgroundColor: cookies.ColorTheme === "default" ? "white" : cookies.ColorTheme === "c2" ? "#cee3e7" : cookies.ColorTheme === "c3" ? "#426c7a" : cookies.ColorTheme === "c4" ? "#8499e4" : cookies.ColorTheme === "c5" ? "#11776c" : "#aaaaaa", boxShadow:"none"}}
      style={{display:"flex",justifyContent:"flex-end",flexDirection:"row"}}
      >
        <Toolbar className={open ? "gg":"gg closed-sidebar"}>
          {(cookies.LayoutTheme === "L1" || cookies.LayoutTheme === "L3" || cookies.LayoutTheme === "L2")  ? (
            <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              height: 64,
              paddingRight: "3px",
            }}
            >
                <img src={Logo} alt="Logo" height={40} />
                {cookies.LayoutTheme !== "L3" && cookies.LayoutTheme !== "L2" && 
                (open ? (
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{
                      color: "black",
                      width: "45px",
                      height: "70px",
                      marginLeft: "auto",
                    }}
                    onClick={handleOnCollapse}
                    >
                    <MenuOpenIcon />
                  </IconButton>
                ) : (
                  <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{
                    color: "black",
                    width: "80px",
                    height: "70px",
                  }}
                  onClick={handleOnCollapse}
                  >
                    <MenuIcon />
                  </IconButton>
                ))}
                
            </Box> 
          ):
            <div className="breadcrump-navbar">
              {moduleName.match(/dashboard|config|user/gi) && moduleName !== "configuration"
              ? <h2 style={{fontWeight:"600"}}>
                <span style={{color:"black"}}>{`${t(`Dashboard.hello`)} `}</span>
                <span>{permissions?.userData?.user?.username}</span>
              </h2>
              :<h2>
                <span>{t(`breadcrump.${moduleName}`)} {subModuleName && ">"}</span>
                <span> {t(`breadcrump.${subModuleName}`)}</span>
                <span> {t(`breadcrump.${subSubModuleName}`) ? "> " + t(`breadcrump.${subSubModuleName}`) : ""}</span>
              </h2>
              }
            </div>}
          <div className="right-navBar">
            <Box className="language-dropdown">
              <Select
                sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                style={{
                  width: "100%",
                  boxShadow: "none",
                  borderRadius: "0",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  border:"none",
                }}
                value={i18next.language}
                onChange={(e) => changeLanguage(e.target.value)}
                IconComponent={() => null}
                className={openProfileBar ? "select-language-open": "select-language-close"}
              >
                <MenuItem value={"fr"} >
                  <img style={{marginRight:"0.5rem"}} src={fr} alt="Français" />
                  FR
                </MenuItem>
                <MenuItem value={"en"} >
                  <img style={{marginRight:"0.5rem"}}  src={en} alt="English" />
                  EN
                </MenuItem>
              </Select>
              <div className="Languagee">{i18next.language.toLocaleUpperCase}</div>
            </Box>
            <Box className="user-dropdown" 
                onClick={()=>{
                  openDropdown && setOpenDropdown(false)
                  }} >
              <Select
                sx={{
                  boxShadow: "none",
                  ".MuiOutlinedInput-notchedOutline": { border: 0 },
                  "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                    {
                      border: 0,
                    },
                  "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      border: 0,
                    }
                }}
                MenuProps={MenuProps}
                className="select-profile"
                notched={false}
                value={"default"}
                IconComponent={() => null}
                onClose={handleCloseDropdown}
                open={openDropdown}
              >
                <MenuItem
                  value="default"
                  sx={{ width: "100%", gap: "10px", display: "none"}}
                >
                  
                  {permissions?.userData?.user &&
                  <div className={`${openProfileBar ? "open-profile-bar" : "close-profile-bar"} response-profile-bar select-languagee`}>
                    <Avatar alt="User Name" className="profil-avatar"
                      onClick={()=>{
                        !openDropdown && !wid && setOpenDropdown(true)
                        !openProfileBar && setOpenProfileBar(true)
                      }}
                      
                      src={`
                        ${vignetteUser
                          ? vignetteUser
                          :newUserData?.Vignette 
                          ? newUserData?.Vignette
                          : DefaultImage
                        }
                      `} />
                    {wid && (
                      <>
                      <div className="profil-name-email">
                        <span className="titlesOfP">{permissions?.userData?.user?.username}</span>
                        <span className="profil-email" >{permissions?.userData?.user?.email}</span>
                      </div>
                      {openDropdown
                      ? <ExpandCircleDownIcon sx={{fontSize: "30px"}}/>
                      : <ExpandCircleDownIcon sx={{fontSize: "30px",transform:"rotate(-90deg)"}}
                        onClick={()=>{
                          setOpenDropdown(true)
                          handleStopTimerDropdown()
                        }}
                       />
                      }
                      </>
                    )}
                  </div>}
                </MenuItem>
                <HasPermission nav={true} permission={"profiles_user_get_detail"}  allowed={!(((permissions?.userData?.modules["profiles_user_get_detail"]) !== true) && (!isAdmin) )} >
                  <MenuItem
                    value={"Profile"}
                    sx={{ width: "100%", gap: "10px"}}
                    onClick={() => {
                      history.push("/user/info");
                    }}
                  >
                    <AccountCircleIcon />
                    <span className="select-profile-text" >{t("ProfileNav")}</span>
                  </MenuItem>
                  <Divider className="divider" />
                </HasPermission>
                <HasPermission nav={true} permission={"options_theme_key_no_api"}  allowed={!(((permissions?.userData?.modules["options_theme_key_no_api"]) !== true) && (!isAdmin) )} >
                  <MenuItem value={"Options"} sx={{ gap: "10px" }}
                    onClick={() => {
                      history.push("/config/panel");
                    }}>
                    <SettingsIcon />
                    <span className="select-profile-text" >{t("OptionsNav")}</span>
                  </MenuItem>
                </HasPermission>
                <HasPermission nav={true} permission={"support_key_no_api"}  allowed={!(((permissions?.userData?.modules["support_key_no_api"]) !== true) && (!isAdmin) )} >
                  <MenuItem value={"API Keys"} sx={{ gap: "10px" }} 
                    onClick={() => {
                      handleOpenModal()
                    }}>
                    <VpnKeyIcon />
                    <span className="select-profile-text" >{t("API Keys")}</span>
                  </MenuItem>
                  <Divider className="divider" />
                </HasPermission>
                <HasPermission nav={true} permission={"support_documentation_no_api"}  allowed={!(((permissions?.userData?.modules["support_documentation_no_api"]) !== true) && (!isAdmin) )} >
                  <MenuItem value={"User Guide"} sx={{ gap: "10px" }}
                   onClick={()=>openLinkInNewWindow()}
                   >
                    <HelpIcon />
                    <span className="select-profile-text">{t("User Guide")}</span>
                  </MenuItem>
                </HasPermission>
                {books.some(obj => window.location.pathname.includes(obj.path) ) && (
                <>
                  <Divider className="divider" />
                  <MenuItem value={"help"} sx={{ gap: "10px" }} onClick={()=>setOpenTheBook(true)}>
                    <HelpIcon  sx={{cursor:"pointer" ,color : cookies.ColorTheme === "default" ? "#1976D2" : cookies.ColorTheme === "c2" ? "#002d3d" : cookies.ColorTheme === "c3" ? "#b4c7e5" : cookies.ColorTheme === "c4" ? "#ffcd38" : cookies.ColorTheme === "c5" ? "#8ee5dc"  : "#F32B84"}} />
                    {/* TODO: traduction */}
                    <span style={{fontSize:"18px"}} >Obtenir l'aide</span>
                  </MenuItem>
                </>
                )}
                <Divider className="divider" />
                <MenuItem value={"Logout"} sx={{ gap: "10px" }} onClick={handleLogout}>
                  <ExitToAppIcon />
                  <span className="select-profile-text">{t("Logout")}</span>
                </MenuItem>
              </Select>
            </Box>
          </div>
          
        </Toolbar>
      </AppBar>
      {/* modal api key */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        className="modal-key"
      >
        <AppBar className="modal-key-header">
          <div>
            <span>{t("Clé Api")}</span>
            <CloseIcon onClick={handleCloseModal} />
          </div>
        </AppBar>
        <ApiKey/>
      </Dialog>
    </div>
  );
};

export default Navbar;
